import * as z from "zod";

export const createClientImportSchema = z.object({
  id: z.boolean(),
  name: z.boolean(),
  base_url: z.boolean(),
  redirect_uris: z.boolean(),
  contact_email: z.boolean(),
});
